import React, { FC } from 'react'
import { Modal } from '../Modal'
import { Wizard } from '../Wizard'
import { LayoutWrapper } from './style'

type Props = {
    MODAL: any
    children: string | JSX.Element
    showWizard: boolean | undefined,
    drupalHost: string,
    currentAct: string
}
export const Layout: React.FC<Props> = ({ MODAL = {}, children, showWizard, drupalHost, currentAct }) => {
    return (
        <LayoutWrapper>
            {children}
            <Wizard showWizard={showWizard} drupalHost={drupalHost} currentAct={currentAct}/>
            <Modal {...MODAL} />
        </LayoutWrapper>
    )
}